<!--
 * @Description:查看说明组件
 * @Author: fal
 * @FilePath: \pc.ui\src\project\components\viewDesc.vue
 * @LastEditTime: 2025-07-01 15:04:25
-->
<template>
  <el-dialog :title="title" :visible="visible" class="deal-modal" :close-on-click-modal="false" append-to-body :before-close="handleClose" :width="diaWidth + 'px'" @open="init">
    <el-divider></el-divider>
    <div>
      <div class="content">
        {{ desc }}
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'viewdesc',
  props: {
    diaWidth: {
      type: String,
      default: '848',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '说明',
    },
    desc: {
      type: String,
      default: '',
    },
  },

  methods: {
    init() {},
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="less" scoped>
.deal-modal {
  :deep(.el-dialog) {
    border-radius: 8px;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 800;
      line-height: 24px;
      color: #333;
    }
    .el-dialog__body {
      padding: 0 20px 20px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
  }

  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0;
  }
  .content {
    .title {
      font-size: 16px;
      font-weight: 800;
      line-height: 24px;
      color: #333;
      margin-bottom: 4px;
    }
    .time {
      margin-top: 16px;
      font-size: 12px;
      font-weight: 500;
      color: #999;
    }
    margin-top: 8px;
    padding: 16px;
    border-radius: 4px;
    background: rgba(237, 237, 237, 0.4);
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }
  .download-file {
    display: flex;
    justify-content: end;
    padding-top: 10px;
    .el-button--plant {
      border-radius: 4px;
      border: 1px solid #1b70ff;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 21.12px;
      color: rgba(27, 112, 255, 1);
    }
  }
}
</style>
